import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';

// Tags shown in the sidebar filter, in order
const SIDEBAR_TAGS = [
  'high_protein',
  'gluten_free',
  'dietary_fiber',
  'low_sugar',
  'low_sodium',
  'low_fat',
  'low_carb',
];

const FilterSidebar = ({ activeTags, onTagToggle }) => {
  const { t } = useLanguage();
  const tagLabels = t.nutrition?.tags ?? {};
  const title = t.filters?.nutritionTitle ?? 'Nutrition Filter';

  return (
    <aside className="explorer-sidebar" aria-label="Explorer filters">
      <section className="filter-group">
        <p className="filter-group-label">{title}</p>
        <div className="style-tag-cloud">
          {SIDEBAR_TAGS.map((tag) => {
            const isActive = activeTags.has(tag);
            return (
              <button
                key={tag}
                type="button"
                className={`style-tag${isActive ? ' is-active' : ''}`}
                aria-pressed={isActive}
                onClick={() => onTagToggle(tag)}
              >
                {tagLabels[tag] ?? tag}
              </button>
            );
          })}
        </div>
      </section>
    </aside>
  );
};

export default FilterSidebar;
